import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { dateToIsoDateString, isoDateStringToDate } from './dateFieldUtils';

/**
 * Date filter field: value is `yyyy-MM-dd` string or '' (matches native date inputs).
 * Single TextField (not multi-section) so dark theme and layout stay consistent.
 */
const AppDateField = ({
  value,
  onChange,
  minDate,
  maxDate,
  disabled,
  ariaLabel,
  placeholder = 'Select date',
}) => {
  return (
    <DatePicker
      enableAccessibleFieldDOMStructure={false}
      value={isoDateStringToDate(value)}
      onChange={(d) => onChange(dateToIsoDateString(d))}
      format="MMM d, yyyy"
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
      slotProps={{
        textField: {
          fullWidth: true,
          size: 'small',
          variant: 'outlined',
          placeholder,
          inputProps: {
            'aria-label': ariaLabel,
            autoComplete: 'off',
            placeholder,
          },
        },
        popper: {
          placement: 'bottom-start',
          sx: { zIndex: 1450 },
        },
        layout: {
          sx: (theme) => ({
            '& .MuiPickersLayout-root': {
              borderRadius: 12,
            },
            '& .MuiPickersLayout-contentWrapper': {
              borderColor:
                theme.palette.mode === 'dark'
                  ? 'rgba(148, 163, 184, 0.15)'
                  : 'rgba(148, 163, 184, 0.2)',
            },
          }),
        },
      }}
    />
  );
};

export default AppDateField;
